/* eslint-disable */
import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import Typography from "@material-ui/core/Typography";
import { TextField, Grid, FormControlLabel, Checkbox } from "@material-ui/core";
import DatePicker from "./DatePicker";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useDispatch, useSelector } from "react-redux";
import {
  addPayment,
  getPaymentAction,
  updatePaymentAction,
} from "../../actions/invoiceActions";
import CheckDate from "./CheckDate";
import { createBank, getBanks } from "../../actions/bankActions";
import { getExistingChecks } from "../../actions/checkActions";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: "#1976D2",
    marginLeft: 0,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "white",
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const Modal = ({ setOpen, open, invoice, id }) => {
  const [openBank, setOpenBank] = useState(false);
  const [openCheck, setOpenCheck] = useState(false);
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("profile"));
  const { payment: updatedPayment } = useSelector((state) => state.invoices);
  //Create a state to add new payment record
  const [payment, setPayment] = useState({
    amountPaid: 0,
    datePaid: new Date(),
    paymentMethod: "Cash",
    note: "",
    paidBy: "",
  });
  const { checks } = useSelector((state) => state.checks);

  const [check, setCheck] = useState({
    datePaid: new Date(),
    bank: "",
    number: "",
    holderName: "",
    guaranteed: false,
    returned: false,
    amountPaid: 0,
    totalAmount: 0,
    _id: null,
  });

  const [bank, setBank] = useState({
    name: "",
  });
  const [loading, setLoading] = useState(false);

  //Material ui datepicker
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  //Crate a state to handle the payment records
  const [paymentRecords, setPaymentRecords] = useState([]);
  const [method, setMethod] = useState({ title: "Cash" });
  const [existingCheck, setExistingCheck] = useState(null);
  const [totalAmountReceived, setTotalAmountReceived] = useState(0);
  const [updatedInvoice, setUpdatedInvoice] = useState({});
  console.log(invoice);
  useEffect(() => {
    setPayment({ ...payment, paymentMethod: method?.title });
  }, [method]);

  useEffect(() => {
    setPayment({ ...payment, datePaid: selectedDate });
  }, [selectedDate]);

  useEffect(() => {
    if (invoice) {
      if (invoice.totalAmountReceived) {
        setPayment({
          ...payment,
          amountPaid:
            Number(invoice.total) - Number(invoice.totalAmountReceived),
          paidBy: user?.result?.name,
        });
        setCheck({
          ...check,
          amountPaid:
            Number(invoice.total) - Number(invoice.totalAmountReceived),
          totalAmount:
            Number(invoice.total) - Number(invoice.totalAmountReceived),
        });
      } else {
        setPayment({
          ...payment,
          amountPaid: Number(invoice.total),
          paidBy: user?.result?.name,
        });
        setCheck({
          ...check,
          amountPaid: Number(invoice.total),
          totalAmount:
            Number(invoice.total) - Number(invoice.totalAmountReceived),
        });
      }
    }
  }, [invoice]);

  useEffect(() => {
    if (invoice?.paymentRecords) {
      setPaymentRecords(invoice?.paymentRecords);
    }
  }, [invoice]);

  useEffect(() => {
    if (id) {
      dispatch(getPaymentAction(id));
    }
  }, [id]);
  useEffect(() => {
    if (updatedPayment._id) {
      setPayment({
        amountPaid: updatedPayment.amountPaid,
        datePaid: updatedPayment.datePaid,
        paymentMethod: updatedPayment.paymentMethod,
        note: updatedPayment.note,
        paidBy: updatedPayment.paidBy,
      });
      setMethod({ title: updatedPayment.paymentMethod });
      if (updatedPayment?.check?._id) {
        setCheck({
          datePaid: updatedPayment.check.datePaid,
          bank: updatedPayment.check.bank,
          number: updatedPayment.check.number,
          holderName: updatedPayment.check.holderName,
          guaranteed: updatedPayment.check.guaranteed,
          returned: updatedPayment.check.returned,
          amountPaid: updatedPayment.check.amountPaid,
          totalAmount: updatedPayment.check.totalAmount,
        });
        setExistingCheck({
          datePaid: updatedPayment.check.datePaid,
          bank: updatedPayment.check.bank,
          number: updatedPayment.check.number,
          holderName: updatedPayment.check.holderName,
          guaranteed: updatedPayment.check.guaranteed,
          returned: updatedPayment.check.returned,
          amountPaid: updatedPayment.check.amountPaid,
          totalAmount: updatedPayment.check.totalAmount,
        });
      }
    }
  }, [updatedPayment._id]);

  //Get the total amount paid
  useEffect(() => {
    if (invoice?.totalAmountReceived) {
      setTotalAmountReceived(invoice?.totalAmountReceived);
    }
  }, [invoice, payment]);

  useEffect(() => {
    setUpdatedInvoice({
      ...invoice,
      status:
        Number(totalAmountReceived) + Number(payment.amountPaid) >=
        invoice?.total
          ? "Paid"
          : "Partial",

      totalAmountReceived: (
        Number(totalAmountReceived) + Number(payment.amountPaid)
      ).toFixed(2),
    });
  }, [payment, paymentRecords, totalAmountReceived, invoice]);

  const handleSubmitPayment = (e) => {
    e.preventDefault();

    setLoading(true);

    if (updatedPayment?._id) {
      dispatch(
        updatePaymentAction(
          {
            ...payment,
            invoiceId: invoice._id,
            check: { ...check, _id: updatedPayment?.check?._id },
          },
          updatedPayment?._id
        )
      ).then(() => {
        handleClose();
        setLoading(false);
        window.location.reload();
      });
    } else {
      if (Number(invoice.total) - totalAmountReceived > 0) {
        dispatch(
          addPayment({ ...payment, invoiceId: invoice._id, check })
        ).then(() => {
          handleClose();
          setLoading(false);
          window.location.reload();
        });
      } else {
        alert("The invoice has been already paid");
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const paymentMethods = [
    { title: "Bank Transfer" },
    { title: "Cash" },
    { title: "Credit Card" },
    { title: "Check" },
    { title: "Existing-Check" },
    { title: "Others" },
  ];

  //bank

  useEffect(() => {
    dispatch(getBanks());
  }, []);
  useEffect(() => {
    dispatch(getExistingChecks());
  }, []);

  const { banks } = useSelector((state) => state.bank);

  const handleAddBank = () => {
    dispatch(createBank(bank, setOpenBank));
  };

  return (
    <div>
      <form>
        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullWidth
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
            style={{ paddingLeft: "20px", color: "white" }}
          >
            {updatedPayment?._id ? "UpdatePayment" : "Record Payment"}
          </DialogTitle>
          <DialogContent dividers>
            <DatePicker
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
            />

            <TextField
              type="number"
              name="amountPaid"
              label="Amount Paid"
              fullWidth
              style={{ padding: 10 }}
              variant="outlined"
              onChange={(e) => {
                setPayment({ ...payment, amountPaid: e.target.value });
                setCheck({ ...check, amountPaid: e.target.value });
              }}
              value={payment.amountPaid}
            />

            <Grid item fullWidth>
              <Autocomplete
                id="combo-box-demo"
                options={paymentMethods}
                getOptionLabel={(option) => option.title || ""}
                style={{ width: "96%", marginLeft: "10px" }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Payment Method"
                    variant="outlined"
                  />
                )}
                value={method}
                onChange={(event, value) => {
                  if (value.title == "Existing-Check") {
                    setOpenCheck(true);
                  }

                  setMethod(value);
                }}
              />
            </Grid>
            {(method.title == "Check" ||
              (method.title == "Existing-Check" && existingCheck)) && (
              <Grid item fullWidth style={{ marginTop: "20px" }}>
                <Grid style={{ display: "flex", alignItems: "center" }}>
                  <Autocomplete
                    id="combo-box-demo"
                    options={banks}
                    getOptionLabel={(option) => option.name}
                    style={{ width: "96%", marginLeft: "10px" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label=" Select Bank"
                        variant="outlined"
                      />
                    )}
                    value={check.bank}
                    onChange={(event, value) =>
                      setCheck({ ...check, bank: value })
                    }
                    disabled={method.title === "Existing-Check"}
                  />
                  <Grid
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => setOpenBank(true)}
                  >
                    <AddIcon /> Add
                  </Grid>
                </Grid>
                <TextField
                  type="text"
                  name="holderName"
                  label="Holder Name"
                  fullWidth
                  style={{ padding: 10, marginTop: "10px" }}
                  variant="outlined"
                  onChange={(e) =>
                    setCheck({ ...check, holderName: e.target.value })
                  }
                  value={check.holderName}
                  InputProps={{
                    readOnly: method.title === "Existing-Check",
                  }}
                />
                <TextField
                  type="text"
                  name="checkNumber"
                  label="Check Number"
                  fullWidth
                  style={{ padding: 10 }}
                  variant="outlined"
                  onChange={(e) =>
                    setCheck({ ...check, number: e.target.value })
                  }
                  value={check.number}
                  InputProps={{
                    readOnly: method.title === "Existing-Check",
                  }}
                />
                <TextField
                  type="number"
                  name="CheckAmount"
                  label="Check amount"
                  fullWidth
                  style={{ padding: 10 }}
                  variant="outlined"
                  onChange={(e) =>
                    setCheck({ ...check, totalAmount: e.target.value })
                  }
                  value={check.totalAmount}
                  InputProps={{
                    readOnly: method.title === "Existing-Check",
                  }}
                />
                {existingCheck && (
                  <span style={{ color: "green" }}>
                    Rest :{" "}
                    {(
                      Number(check.totalAmount) -
                      Number(existingCheck.amountPaid)
                    ).toFixed(2)}
                  </span>
                )}
                <CheckDate check={check} setCheck={setCheck} method={method} />
                <FormControlLabel
                  label="Guaranteed"
                  control={
                    <Checkbox
                      checked={
                        method.title === "Existing-Check"
                          ? existingCheck.guaranteed
                          : check.guaranteed
                      }
                      onChange={(e) =>
                        setCheck({ ...check, guaranteed: e.target.checked })
                      }
                    />
                  }
                />
              </Grid>
            )}

            <TextField
              type="text"
              name="note"
              label="Note"
              fullWidth
              style={{ padding: 10 }}
              variant="outlined"
              onChange={(e) => setPayment({ ...payment, note: e.target.value })}
              value={payment.note}
            />
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={handleSubmitPayment}
              variant="contained"
              style={{ marginRight: "25px" }}
              disabled={loading}
            >
              Save Record
            </Button>
          </DialogActions>
        </Dialog>
      </form>
      <Dialog
        onClose={() => setOpenBank(false)}
        aria-labelledby="customized-dialog-title"
        fullWidth
        open={openBank}
      >
        <DialogTitle
          id="customized-dialog-title"
          style={{ paddingLeft: "20px", color: "white" }}
          onClose={() => setOpenBank(false)}
        >
          Add Bank
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            type="text"
            name="bankName"
            label="Bank name"
            fullWidth
            style={{ padding: 10 }}
            variant="outlined"
            onChange={(e) => setBank({ name: e.target.value })}
            value={bank.name}
          />
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleAddBank}
            variant="contained"
            style={{ marginRight: "25px" }}
            disabled={loading}
          >
            Add Bank
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        onClose={() => setOpenCheck(false)}
        aria-labelledby="customized-dialog-title"
        fullWidth
        open={openCheck}
      >
        <DialogTitle
          id="customized-dialog-title"
          style={{ paddingLeft: "20px", color: "white" }}
          onClose={() => setOpenCheck(false)}
        >
          Select Check
        </DialogTitle>
        <DialogContent dividers>
          <Autocomplete
            id="combo-box-demo"
            options={checks}
            getOptionLabel={(option) =>
              `${option.holderName} - ${option.number} ` || ""
            }
            style={{ width: "96%", marginLeft: "10px" }}
            renderInput={(params) => (
              <TextField {...params} label="Select Check" variant="outlined" />
            )}
            value={existingCheck}
            onChange={(event, value) => {
              setExistingCheck(value);

              setCheck({
                datePaid: value.datePaid,
                bank: value.bank,
                number: value.number,
                holderName: value.holderName,
                guaranteed: value.guaranteed,
                returned: value.returned,
                amountPaid: check?.amountPaid,
                totalAmount: value.totalAmount,
                _id: value._id,
              });
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenCheck(false)}
            variant="contained"
            style={{ marginRight: "25px" }}
            disabled={loading}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Modal;
